<template>
    <div style="overflow-y: scroll; height: 100%; -webkit-overflow-scrolling: touch;">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="margin-top: 40px;">
        <el-form label-width="80px" ref="form" :model="userData">
          <el-form-item label="连接地址" prop="userAddress">
            <el-input v-model="userData.userAddress" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="店铺号" prop="shopId">
            <el-input v-model="userData.shopId" auto-complete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="店铺类型:" prop="shopType">
            <span>{{ userData.shopType == 0?'算力店铺':userData.shopType == 1?'普通店铺':'本地生活' }}</span>
          </el-form-item>
          <el-form-item label="店铺名称" prop="shopName">
            <el-input v-model="userData.shopName" auto-complete="off" :disabled="!pageStutas" placeholder="请输入店铺名称"></el-input>
          </el-form-item>
          <el-form-item label="店铺地址" prop="shopAddress">
            <el-input v-model="userData.shopAddress" auto-complete="off" :disabled="!pageStutas" placeholder="请输入店铺地址"></el-input>
          </el-form-item>
          <el-form-item label="店铺电话" prop="shopPhone">
            <el-input v-model="userData.shopPhone" auto-complete="off" :disabled="!pageStutas" placeholder="请输入店铺电话"></el-input>
          </el-form-item>
          <el-form-item label="店铺状态" prop="shopStatus">
            <span>{{ userData.status == 0?'已开业':'已歇业' }}</span>
            <el-switch @change="changeStatus" v-model="userData.shopStatus"></el-switch>
          </el-form-item>
          <el-form-item label="店铺头像" prop="shopPhoto" v-if="!pageStutas">
            <img :src="userData.shopPhoto" alt="">
          </el-form-item>
          <el-form-item label="宣传图"  prop="allPhoto" v-if="!pageStutas">
            <div style="display: flex;align-items: center;" v-if="userData.allPhoto != null">
              <div v-for="(item, index) in userData.allPhoto.split(',')" :key="index">
                <img style="min-width: 100px;min-height: 150px;margin-right: 10px;" :src="item" alt="">
              </div>
            </div>
          </el-form-item>
          <el-form-item label="店铺头像(仅支持一张)" v-if="pageStutas" label-width="185px" prop="shopPhoto">
            <el-upload
                class="upload-demo"
                action="https://www.neww.site:446/shop/uploadimg"
                :headers="headersData"
                :on-success="handleSuccess2"
                :on-error="handleError"
                :file-list="fileList2"
                name="test"
                list-type="picture">
                <el-button size="small" type="primary">点击上传店铺头像</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="宣传图" v-if="pageStutas" prop="userName">
            <el-upload
                class="upload-demo"
                action="https://www.neww.site:446/shop/uploadimg"
                :headers="headersData"
                :on-success="handleSuccess"
                :on-error="handleError"
                :file-list="fileList"
                name="test"
                list-type="picture">
                <el-button size="small" type="primary">点击上传店铺宣传图片</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="pageStutas">
          <el-button size="big" type="primary" :loading="loading" class="title" @click="editForm()">保存</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button size="big" type="primary" :loading="loading" class="title" @click="submitForm()">编辑</el-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {VueEditor, Quill} from "vue2-editor";
  import { getAllShop, exShopInfo } from '../../api/userMG'
  export default {
    name: 'Tinymce',
    components:{
      VueEditor
    },
    data() {
      return {
        loading: false,
        pageStutas: false,
        onloadImgData: [],
        onloadImgData2: [],
        userData: {
          shopName: '',
          shopPhone: '',
          shopPhoto: '',
          shopAddress: '',
          allPhoto: [],
          shopStatus: false
        },
        formInline: {
            page: 1,
            limit: 10,
            belongId: 0
        },
        fileList: [],
        fileList2:[],
        headersData:{
            id:localStorage.getItem('loginId'),
            hash:localStorage.getItem('logintoken')
        },
      }
    },
    created() {
        this.getdata(this.formInline)
    },
    methods: {
        clickType(e) {
          this.formInline.belongId = e;
          this.getdata(this.formInline);
        },
        getdata(valList) {
            this.loading = true
            getAllShop(valList).then(res => {
                this.loading = false
                if (res.success == false) {
                    this.$message({
                        type: 'info',
                        message: res.msg
                    })
                } else {
                  this.userData = res.data[0];
                  this.userData.shopStatus = res.data[0].status == 0?true:false;
                }
            })
            .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('请稍后再试！')
            })
        },
        handleSuccess2(file,fileList) {
            this.userData.shopPhoto = '';
            this.fileList2.name = fileList.name;
            this.fileList2.url = "https://www.neww.site:446"+fileList.response.url;
            this.userData.shopPhoto = this.fileList2.url;
        },
        handleSuccess(file,fileList) {
            this.userData.allPhoto = []
            this.fileList.name = fileList.name;
            this.fileList.url = "https://www.neww.site:446"+fileList.response.url;
            this.onloadImgData.push(fileList)
            this.onloadImgData.forEach(item => {
                this.userData.allPhoto.push("https://www.neww.site:446"+item.response.url)
            })
        },
        handleError(err) {
            console.log(err)
        },
        changeStatus(e) {
          console.log(e)
          let typeS = e?0:2;
          exShopInfo({del: typeS})
            .then(res => {
                this.loading = false
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: '数据保存成功！'
                    })
                    this.getdata();
                    this.userData.shopStatus = e;
                    this.pageStutas = false;
                } else {
                  this.$message({
                      type: 'info',
                      message: res.msg
                  })
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
            })
        },
        submitForm() {
          this.getdata(this.formInline)
          this.pageStutas = true;
        },
        editForm () {
            this.loading = true;
            if(this.userData.shopName == '' || this.userData.shopPhoto == '' || this.userData.shopPhone == '' || this.userData.shopAddress == '') {
              this.$message({
                type: 'info',
                message: '请完善编辑内容'
              })
              this.loading = false;
              return ;
            }
            exShopInfo({shopName: this.userData.shopName,shopPhoto:this.userData.shopPhoto,shopPhone:this.userData.shopPhone,shopAddress:this.userData.shopAddress,allPhoto:this.userData.allPhoto})
            .then(res => {
                this.loading = false
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: '数据保存成功！'
                    })
                    this.getdata();
                    this.pageStutas = false;
                } else {
                  this.$message({
                      type: 'info',
                      message: res.msg
                  })
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
            })
        }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .editor-custom-btn-container {
    position: absolute;
    right: 100px;
    top: 100px;
    /*z-index: 2005;*/
  }
  .tinymce-textarea {
    visibility: hidden;
    z-index: -1;
  }
  .fullscreen .editor-custom-btn-container {
    z-index: 10000;
    position: fixed;
  }
  
  .editor-upload-btn {
    display: inline-block;
  }
  .dialog-footer{
    margin-left: 80px;
    margin-top: 40px;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/system/userList.vue